// @ts-strict-ignore
import { m } from "framer-motion";
import styled from "styled-components";
import Input from "components/parts/input/Cryptopedia";
import { ErrorText as BaseErrorText } from "components/parts/input/Cryptopedia/style";
import Button from "components/parts/button";
import NextImage from "components/parts/NextImage";
import { Button as HubbleButton, mediaQuery } from "@hubble/web";

export const MobileSideNavContainer = styled(m.div)`
  width: 100vw;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  bottom: 0;
  box-sizing: border-box;
  padding: 3rem 1rem 4rem;
  background: ${({ theme }) => theme.backgroundColors.primary};
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.1);
  z-index: 100;

  @media ${mediaQuery.tabletSmUp} {
    display: none;
  }
`;

export const MobileSideNavSignInButton = styled(HubbleButton.Primary)`
  width: calc(100% - 2rem);
  box-sizing: border-box;
  position: absolute !important;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
`;

export const Backdrop = styled(m.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.backgroundColors.secondary};
  opacity: 0;
  bottom: 0;
`;

export const CloseButton = styled(NextImage).attrs({
  height: 14,
  width: 14,
  style: {
    position: "absolute",
    top: "1rem",
    right: "1rem"
  }
})``;

export const SubscribeForm = styled.form`
  padding: 32px 0;
`;

export const SubscribeSuccessContainer = styled.div`
  padding: 24px 0;
  text-align: center;
`;

export const SubscribeInput = styled(Input)`
  width: 100%;
`;

export const SubscribeButton = styled(Button)`
  width: 100%;
  height: 48px;
  font-size: 16px;
  margin-top: 16px;
`;

export const ErrorText = styled(BaseErrorText)`
  position: static;
  margin-top: 16px;
  text-align: center;
`;

export const MenuContainer = styled.div`
  margin-bottom: 4rem;
`;
